import React from "react";
import "./about.css";

import { FaAward } from "react-icons/fa";
import { AiFillProject } from "react-icons/ai";
import { VscFolderLibrary } from "react-icons/vsc";
const About = () => {
  return (
    <section id="about">
      <h5>Get to Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
           
            <img src="https://media.giphy.com/media/kl81GtX2bdVvw3ezYz/giphy.gif" alt="about"></img>
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>1000+ hrs Coding </small>
            </article>
            <article className="about__card">
              <AiFillProject className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Clients </h5>
              <small>0 Clients</small>
            </article>
          </div>
          <br />Web Developer with expertise of React.js, Redux, Cloud Firestore, HTML and CSS.
                <br /><br/>
                I am passionate programmer and a learner, born and brought up in India. I have done my full stack web development from Masai school.
                <br />
                <br /> 
                <br />I love learning about new technologies, what problems are they solving and How can I use them to build better and scalable products.
                <br /> <br />
          <a href="#contact" className=" btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
